<template>
  <el-dialog width="510px" :visible="visible" @close="$emit('update:visible', false)">
    <upload-list ref="uploadList" :preview="true"></upload-list>
  </el-dialog>
</template>

<script>
import UploadList from './upload-list'
import { fileUrlAdapter } from '@/common/filters'
import { isImage } from '@/common/utils/validate'

export default {
  name: 'PreviewDialog',
  components: { UploadList },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: Array
  },
  watch: {
    data: {
      handler: 'handlerData',
      immediate: true
    }
  },
  methods: {
    handlerData() {
      if (this.data.length === 0) {
        return
      }
      const file = []
      this.data.forEach(fk => {
        const obj = {}
        obj.url = fileUrlAdapter(fk)
        if (!isImage(fk)) {
          obj.type = fk.split('.')[1].toUpperCase()
        }
        file.push(obj)
      })
      this.$nextTick(() => {
        this.$refs.uploadList.setFileList(file)
      })
    }
  }
}
</script>
